import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  Icon,
  Icons,
  Stack,
} from '@nextiva/next-ui-components';
import { RegistrationApprovedProps } from 'interface/WizardV3';
import { CompanyTypeCell } from '../CompanyTypeCell';
import { useWizardContextV3 } from '../CampaignDialog/WizardContextV3/WizardContextV3';
import { formatPhoneNumber } from '../CampaignDialog/WizardContextV3/customValidations';
import { useGetPhoneNumberSoleProprietor } from '../CampaignDialog/WizardContextV3/useGetPhoneNumberSoleProprietor';

const dataTestId = 'PlatformAdminUI-Messaging-RegistrationApproved';
export function RegistrationApproved({
  showPhoneNumberSP,
}: RegistrationApprovedProps) {
  const { enablementInfo } = useWizardContextV3();
  const companyType = enablementInfo?.companyType;
  const {
    data: phoneNumberSP,
    isLoading: isLoadingPhoneNumberSP,
  } = useGetPhoneNumberSoleProprietor();
  const [phoneNumber, setPhoneNumber] = useState('');

  useEffect(() => {
    if (phoneNumberSP?.data?.phoneNumber) {
      setPhoneNumber(phoneNumberSP.data.phoneNumber);
    }
  }, [phoneNumberSP?.data?.phoneNumber]);
  return (
    <Grid container rowSpacing={3} data-testid={dataTestId}>
      <Grid container columnSpacing={6} data-testid={`${dataTestId}-Column`}>
        <Grid item>
          <Typography
            variant="body2"
            color="#0B1029"
            fontWeight={800}
            marginBottom="8px"
          >
            Status:
          </Typography>
          <Stack direction="row" alignItems="center" gap={1}>
            <Icon
              icon={Icons.checkCircle}
              size={16}
              sx={{ color: '#008763' }}
            />
            <Typography variant="body2" color="#005A39">
              Approved
            </Typography>
          </Stack>
        </Grid>
        <CompanyTypeCell companyType={companyType} isApproved={false} />
        {!!phoneNumberSP?.data?.phoneNumber &&
          !isLoadingPhoneNumberSP &&
          showPhoneNumberSP && (
            <Grid item>
              <Typography
                variant="body2"
                color="#0B1029"
                fontWeight={800}
                marginBottom="8px"
              >
                Business messaging number:
              </Typography>
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography variant="body2" color="#0B1029">
                  {formatPhoneNumber(phoneNumber)}
                </Typography>
              </Stack>
            </Grid>
          )}
      </Grid>
    </Grid>
  );
}
